import { ScriptureItem } from "api/typedefs/ScriptureItem";
import { useEffect } from "react";
import {
  useScriptureRouting,
  getMaxNumParallels
} from "components/Bible/useScriptureRouting";

export function getVerseIds(
  chapterContent: ScriptureItem[] | undefined
): string[] {
  if (!chapterContent || !chapterContent.length) return [];

  const verseItems = ([] as (ScriptureItem | undefined)[])
    .concat(...chapterContent.map(({ items }) => items))
    .filter(item => !!item) as ScriptureItem[];

  const chapterVerseIdList = verseItems
    .map(({ attrs }) => attrs && attrs.verseId)
    .filter(id => id);
  const dedupedChapterVerseIdlist = [...new Set(chapterVerseIdList)];
  const verseIds = dedupedChapterVerseIdlist
    .map(chapterVerseId => chapterVerseId.split(".").pop())
    .filter(verseId => verseId) as string[];

  return verseIds;
}

// NOTE: The "orientationchange" event is fired before the "resize" event
// takes place. In order to be able to have getMaxNumParallels to return
// the correct value we need to nest the "resize" event inside of the
// "orientation" event in order to capture the "resize" event that happens
// directly after the "orientationchange".
export const useParallelManager = () => {
  const { parallelBibleIds, removeAllParallels } = useScriptureRouting();
  const parallelCount = parallelBibleIds.length;

  useEffect(() => {
    const removeExcessParallels = () => {
      if (parallelCount <= getMaxNumParallels()) return;
      removeAllParallels();
    };
    const handleResize = () => {
      window.addEventListener("resize", removeExcessParallels);
    };
    window.addEventListener("orientationchange", handleResize);

    return () => {
      window.removeEventListener("orientationchange", handleResize);
      window.removeEventListener("resize", removeExcessParallels);
    };
  }, [parallelCount, removeAllParallels]);
};
